import React, { useCallback, useEffect } from 'react'
import Link from 'redux-first-router-link'
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser'
import logoLight from 'assets/lettermark-light.svg'
import logoChristmasLight from 'assets/lettermark-chrismas-light.png'
import UserItem from 'components/App/DesktopView/Layout/GlobalNav/UserItem'
import { doOpenMainPage } from 'actions/pages'
import { userPlus as UserPlusIcon } from 'assets/icons/groove/v2'
import { useDrawer } from 'ducks/drawers/hooks'
import { DRAWER_TYPE_AGENT_ADD } from 'ducks/drawers/types'
import Search from 'subapps/ticketing/components/TicketList/Header/Search'
import { selectHasRealMailboxes } from 'selectors/trial_setup'
import { doFetchBootstrapData } from 'actions/app'
import { isBoostrappedSelector } from 'selectors/app'
import IconItem from '../GlobalNav/IconItem'
import Help from '../GlobalNav/Help'
import Nav from './Nav'
import { styles } from './styles'

const toMainPage = doOpenMainPage()
const showChristmasLogo = new Date().getMonth() === 11
const currentLogo = showChristmasLogo ? logoChristmasLight : logoLight

const TopNav = ({ active }) => {
  const dispatch = useDispatch()
  const isManager = useSelector(selectCurrentUserIsAdminOrOwner)
  const isAppBootstrapped = useSelector(isBoostrappedSelector)
  const showSearch = useSelector(selectHasRealMailboxes)
  const { openDrawer: openAddDrawer } = useDrawer({
    type: DRAWER_TYPE_AGENT_ADD,
    lazyLoad: true,
  })

  const handleAddTeammates = useCallback(
    () => {
      openAddDrawer('new', {
        additionalProps: { title: `Add ${app.t('Agent')}` },
      })
    },
    [openAddDrawer]
  )

  useEffect(
    () => {
      if (!isAppBootstrapped) {
        dispatch(doFetchBootstrapData())
      }
    },
    [dispatch, isAppBootstrapped]
  )

  return (
    <div css={styles.base} data-test-id="TopNav">
      <Link
        css={[styles.logo, showChristmasLogo && styles.christmasLogo]}
        to={toMainPage}
      >
        <img src={currentLogo} alt="logo" />
      </Link>
      <Nav className="grui mx-5" active={active} />
      <div className="grui flex items-center flex-1 pr-12">
        {showSearch && (
          <Search
            className="grui mr-16"
            css={styles.search}
            placeholder={`Search your ${app.t('mailbox')}…`}
          />
        )}
        <div className="grui ml-auto flex items-center">
          {isManager && (
            <IconItem onClick={handleAddTeammates}>
              <UserPlusIcon />
            </IconItem>
          )}
          <Help />
          <UserItem />
        </div>
      </div>
    </div>
  )
}

export default React.memo(TopNav)
